import { Flex, Table, message } from 'antd';
import Link from 'antd/lib/typography/Link';

import { useDeleteSingleCollection } from '@/api/monitor_collections';
import CollectionsMultiButton from '@/components/common/CollectionsMultiButton';
import { IVideoCollectionItem } from '@/ts';

import { TCollection } from '..';

type TProps = {
	data: any;
	columns: any;
	onTableChange: any;
	isLoading: boolean;
	isFetching?: boolean;
	pagination: any;
	setPagination: any;
	onViewClick: (collection: TCollection, data: any) => void;
	onEditClick: (data: any) => void;
};

export default function CreatorsCollectionsTable({
	data,
	columns,
	onTableChange,
	isLoading,
	pagination,
	setPagination,
	onViewClick,
	onEditClick,
}: TProps) {
	const { mutate: deleteCollection, isLoading: isDeleteLoading } =
		useDeleteSingleCollection('creators');

	return (
		<Table
			size="small"
			// dataSource={data?.data?.data?.results}
			dataSource={data}
			columns={[
				{
					title: 'Title / Description',
					dataIndex: 'title',
					key: 'title',
					// sorter: false,
					ellipsis: true,
					width: 90,
					render: (_: any, record: IVideoCollectionItem) => {
						return (
							<Flex vertical>
								<Link
									onClick={(e) => {
										e.preventDefault();
										onViewClick('creators-group', record);
									}}
								>
									{record?.title}
								</Link>
								<span style={{ color: 'gray' }}>{record?.description}</span>
							</Flex>
						);
					},
				},
				...columns,
				{
					title: 'Actions',
					// ellipsis: true,
					width: 65,
					dataIndex: 'actions',
					key: 'actions',
					fixed: 'right',
					render: (_: any, record: IVideoCollectionItem) => {
						return (
							<Flex justify="center" align="center" style={{ gap: '4px' }}>
								<CollectionsMultiButton
									record={record}
									type="creators"
									onViewClick={() => onViewClick('creators-group', record)}
									onEditClick={() => onEditClick(record)}
								/>
							</Flex>
						);
					},
				},
			]}
			style={{ width: '100%' }}
			rowClassName="editable-row"
			rowKey={'id'}
			onChange={onTableChange}
			loading={isLoading || isDeleteLoading}
			bordered
			pagination={{
				total: pagination?.total || 1,
				showSizeChanger: true,
				current: pagination?.page,
				pageSizeOptions: [10, 25, 50],
				onChange: (page: number, pageSize: number) => {
					setPagination((cur: any) => ({ ...cur, page, limit: pageSize }));
				},
			}}
		/>
	);
}
